import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/console/default/components/WeeklyRevenue";
import TotalSpent from "views/console/default/components/TotalSpent";
import PieChartCard from "views/console/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard, MdPeopleAlt, 
  MdCalendarMonth, MdLineAxis, MdOutlineDesktopMac 
} from "react-icons/md";
import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";
import tableDataTopCreators from "views/admin/marketplace/variables/tableDataTopCreators.json";
import { tableColumnsTopCreators } from "views/admin/marketplace/variables/tableColumnsTopCreators";

import Widget from "components/widget/Widget";
import CheckTable from "views/console/default/components/CheckTable";
import ComplexTable from "views/console/default/components/ComplexTable";
import DailyTraffic from "views/console/default/components/DailyTraffic";
import TaskCard from "views/console/default/components/TaskCard";
import TimeCard from "views/console/default/components/TimeCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import StaffList from "views/console/default/components/StaffList";
import AnnouncementCard from "./components/AnnouncementCard";
import { useSelector } from "react-redux";

const Dashboard = () => {

  const user = useSelector((state) => state.auth.user);

  return (
    <div>
      {(user?.user_level <= 2 || user?.user_level === 5) && <>
        <div className=" mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-4">
            <Widget
              icon={<MdLineAxis className="h-7 w-7" />}
              title={"Leave Balance"}
              subtitle={`VL: 10, SL: 10`}
            />
            <Widget
              icon={<MdCalendarMonth className="h-6 w-6" />}
              title={"Filed Leave"}
              subtitle={"2025-12-23"}
            />
            <Widget
              icon={<MdOutlineDesktopMac className="h-6 w-6" />}
              title={"Assigned Tasks"}
              subtitle={"4"}
            />  
        </div>
        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-4">
          <TimeCard title="Today Is" withClockIn={true}/>
          <MiniCalendar className="w-full"/>    
          <AnnouncementCard/>	
        </div>
      </>
      }

      {(user?.user_level <= 2 || user?.user_level === 4) && <>
        <div className=" mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-4">
            <Widget
              icon={<MdPeopleAlt className="h-7 w-7" />}
              title={"Total Sfaff"}
              subtitle={"979"}
            />
            <Widget
              icon={<MdDashboard className="h-6 w-6" />}
              title={"Total Payroll"}
              subtitle={"$876,543.21"}
            />
            <Widget
              icon={<IoDocuments className="h-6 w-6" />}
              title={"Total Invoice"}
              subtitle={"$1,642,123.39"}
            />  
        </div>
        
        <div className=" mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
          <WeeklyRevenue />
            <TotalSpent />	        
        </div>
    	</>
      }
      {/* <div className="hidden mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">

        <TimeCard/>

        <TaskCard />

        <StaffList
          extra="mb-5"
          tableData={tableDataTopCreators}
          columnsData={tableColumnsTopCreators}
        />

      </div> */}

      {/* Card widget */}

      <div className="hidden mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Staff"}
          subtitle={"$340.5"}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Total Payroll"}
          subtitle={"$1,000"}
        />
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"Total Invoice"}
          subtitle={"$642.39"}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Sales"}
          subtitle={"$574.34"}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"New Tasks"}
          subtitle={"145"}
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Total Projects"}
          subtitle={"$2433"}
        />
      </div>

      {/* Charts */}

      <div className="hidden mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div>

      {/* Tables & Charts */}

      <div className="hidden mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        {/* Check Table */}
        <div>
          <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div>

        {/* Traffic chart & Pie Chart */}

        <div className="hidden grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard />
        </div>

        {/* Complex Table , Task & Calendar */}

        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />

        {/* Task chart & Calendar */}

        <div className="hidden grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
